// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"975":"61563201","989":"44f74b9d"}[chunkId] + ".chunk.js";
};